import {
  PROJECT_STATUS_LABELS,
  TASK_STATUS_LABELS,
  type ProjectStatus,
  type TaskStatus,
} from '@stromo/shared';

const STATUS_CLASS: Record<ProjectStatus | TaskStatus, string> = {
  open: 'badge-open',
  planning: 'badge-planning',
  in_progress: 'badge-progress',
  delayed: 'badge-delayed',
  completed: 'badge-done',
};

interface StatusBadgeProps {
  status: ProjectStatus | TaskStatus;
  kind?: 'project' | 'task';
}

export function StatusBadge({ status, kind = 'project' }: StatusBadgeProps) {
  const labels = kind === 'project' ? PROJECT_STATUS_LABELS : TASK_STATUS_LABELS;
  const label = (labels as Record<string, string>)[status] ?? status;
  return <span className={`badge ${STATUS_CLASS[status] ?? 'badge-open'}`}>{label}</span>;
}
